import { render, staticRenderFns } from "./ProfileSettings.vue?vue&type=template&id=2c677ac8&"
import script from "./ProfileSettings.vue?vue&type=script&lang=js&"
export * from "./ProfileSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports